import React from 'react';

const Terms = () => {
  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-10">
          <div className="glass-card" style={{ position: 'relative', zIndex: 20 }}>
            <h1 className="commercial-heading text-center mb-4">Terms of Service</h1>
            <p className="text-center mb-5" style={{ color: '#666', fontSize: '0.9rem' }}>
              Last Updated: January 11, 2026
            </p>

            <div style={{ color: '#000000', lineHeight: '1.8' }}>
              <h2 className="mt-4 mb-3" style={{ fontSize: '1.5rem', fontWeight: '600' }}>1. Acceptance of Terms</h2>
              <p>
                By accessing and using VowAuthor ("the Service"), you accept and agree to be bound by the terms and 
                provisions of this agreement. If you do not agree to these Terms of Service, please do not use the Service.
              </p>

              <h2 className="mt-4 mb-3" style={{ fontSize: '1.5rem', fontWeight: '600' }}>2. Description of Service</h2>
              <p>
                VowAuthor provides an online wedding vow generation service. Upon purchase, customers receive five (5) 
                single-use redemption codes that can be used to generate personalized wedding vows with downloadable PDF files.
              </p>

              <h2 className="mt-4 mb-3" style={{ fontSize: '1.5rem', fontWeight: '600' }}>3. Account and Purchase Terms</h2>
              <h3 className="mt-3 mb-2" style={{ fontSize: '1.2rem', fontWeight: '600' }}>3.1 Purchase</h3>
              <p>
                When you make a purchase through VowAuthor, you agree to pay the stated price of $9.99 for a package 
                of five (5) redemption codes. All payments are processed securely through Stripe.
              </p>
              
              <h3 className="mt-3 mb-2" style={{ fontSize: '1.2rem', fontWeight: '600' }}>3.2 Redemption Codes</h3>
              <p>
                Each redemption code may only be used once. Codes do not expire but cannot be reused after redemption. 
                Codes are delivered via email and are your responsibility to maintain. Lost or stolen codes cannot be replaced.
              </p>

              <h3 className="mt-3 mb-2" style={{ fontSize: '1.2rem', fontWeight: '600' }}>3.3 Refund Policy</h3>
              <p>
                Due to the digital nature of our product and immediate delivery of redemption codes, all sales are final. 
                Refunds will not be provided except in cases of technical failure that prevents the use of purchased codes.
                However, if you are not satisfied with the generated vows, we offer one complimentary redo per code.
              </p>

              <h2 className="mt-4 mb-3" style={{ fontSize: '1.5rem', fontWeight: '600' }}>4. Content and Usage</h2>
              <h3 className="mt-3 mb-2" style={{ fontSize: '1.2rem', fontWeight: '600' }}>4.1 Your Content</h3>
              <p>
                You are solely responsible for the accuracy and appropriateness of all information you provide when 
                generating wedding vows. You warrant that you have the consent of any individuals mentioned in your vows
                and that the information you provide is truthful.
              </p>

              <h3 className="mt-3 mb-2" style={{ fontSize: '1.2rem', fontWeight: '600' }}>4.2 Prohibited Uses</h3>
              <p>You agree not to use the Service to:</p>
              <ul style={{ marginLeft: '2rem' }}>
                <li>Generate false, misleading, or defamatory content</li>
                <li>Violate any applicable laws or regulations</li>
                <li>Infringe upon the rights of others</li>
                <li>Attempt to gain unauthorized access to the Service or its systems</li>
                <li>Use automated means to access the Service without permission</li>
                <li>Generate content that is inappropriate, offensive, or harmful</li>
              </ul>

              <h3 className="mt-3 mb-2" style={{ fontSize: '1.2rem', fontWeight: '600' }}>4.3 Generated Content</h3>
              <p>
                Once generated, you retain all rights to the wedding vow content. You may use, reproduce, distribute, 
                and display the generated vows for any lawful purpose, including your wedding ceremony and personal keepsakes.
              </p>

              <h2 className="mt-4 mb-3" style={{ fontSize: '1.5rem', fontWeight: '600' }}>5. Data Storage and Access</h2>
              <p>
                Generated wedding vows and associated PDF files are stored for ninety (90) days from the date of creation. 
                After this period, the files are automatically deleted from our servers. Any PDFs downloaded during this 
                period remain your property. We recommend downloading your vows promptly as a keepsake.
              </p>

              <h2 className="mt-4 mb-3" style={{ fontSize: '1.5rem', fontWeight: '600' }}>6. Intellectual Property</h2>
              <p>
                The Service, including its original content, features, and functionality, is owned by VowAuthor and is 
                protected by international copyright, trademark, and other intellectual property laws. The VowAuthor 
                name, logo, and branding may not be used without express written permission.
              </p>

              <h2 className="mt-4 mb-3" style={{ fontSize: '1.5rem', fontWeight: '600' }}>7. Disclaimer of Warranties</h2>
              <p>
                THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, 
                INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND 
                NON-INFRINGEMENT. We do not warrant that the Service will be uninterrupted, error-free, or completely secure.
                Wedding vows generated are suggestions and should be reviewed and personalized by you before use in your ceremony.
              </p>

              <h2 className="mt-4 mb-3" style={{ fontSize: '1.5rem', fontWeight: '600' }}>8. Limitation of Liability</h2>
              <p>
                TO THE MAXIMUM EXTENT PERMITTED BY LAW, VOWAUTHOR SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, 
                CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY, 
                OR ANY LOSS OF DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES RESULTING FROM YOUR USE OF THE SERVICE.
              </p>

              <h2 className="mt-4 mb-3" style={{ fontSize: '1.5rem', fontWeight: '600' }}>9. Rate Limiting and Security</h2>
              <p>
                To protect the Service from abuse, we implement rate limiting on code validation attempts. After five (5) 
                failed validation attempts, access will be temporarily restricted for one (1) hour. This is necessary to 
                prevent automated attacks and ensure service availability for all users.
              </p>

              <h2 className="mt-4 mb-3" style={{ fontSize: '1.5rem', fontWeight: '600' }}>10. Modifications to Service</h2>
              <p>
                We reserve the right to modify, suspend, or discontinue the Service (or any part thereof) at any time with 
                or without notice. We shall not be liable to you or any third party for any modification, suspension, or 
                discontinuance of the Service.
              </p>

              <h2 className="mt-4 mb-3" style={{ fontSize: '1.5rem', fontWeight: '600' }}>11. Changes to Terms</h2>
              <p>
                We reserve the right to update these Terms of Service at any time. We will notify users of any material 
                changes by posting the new Terms of Service on this page and updating the "Last Updated" date. Your 
                continued use of the Service after such changes constitutes acceptance of the new terms.
              </p>

              <h2 className="mt-4 mb-3" style={{ fontSize: '1.5rem', fontWeight: '600' }}>12. Governing Law</h2>
              <p>
                These Terms shall be governed by and construed in accordance with the laws of the United States, without 
                regard to its conflict of law provisions.
              </p>

              <h2 className="mt-4 mb-3" style={{ fontSize: '1.5rem', fontWeight: '600' }}>13. Contact Information</h2>
              <p>
                If you have any questions about these Terms of Service, please contact us using the contact form on our 
                Help page.
              </p>

              <div className="mt-5 pt-4" style={{ borderTop: '1px solid rgba(0,0,0,0.1)', textAlign: 'center', color: '#666' }}>
                <p>© {new Date().getFullYear()} VowAuthor. A Lavation Company. All rights reserved.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
